// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___9axBq","panel":"panel___3k2pt","point":"point___2obIP"};